import { ColumnType } from 'antd/es/table';
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { TooltipComponent } from "../../components/Component";
import { tasksApis } from '../../api/NewTasks';

const OnHoldTasksReport = () => {
    const [userIdFilterData, setUserIdFilterData] = useState([]);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { id: projectId, projectName } = location.state || {};

    const columns: ColumnType<any>[] = [

        {
            title: "Task Name",
            dataIndex: "taskName",
            key: "taskName",
            width: 150,
            fixed: "left",
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`task-${record?.taskId}`}
                            onClick={() => {
                                console.log("Task Name Clicked:");
                                navigate(`/pms/project/task-detail/${record.taskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                        <TooltipComponent
                            iconClass="info-circle text-info"
                            icon={""}
                            id={`task-${record?.taskId}`}
                            direction="right"
                            text={"Click To View " + text + " Details"}
                            containerClassName={"mt-1"}
                        />
                    </>
                );
            },
        },
        {
            title: "Onhold Since",
            dataIndex: "onholdDate",
            key: "onholdDate",
            width: 100,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Created By ",
            dataIndex: "createdByName",
            key: "createdByName",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Owner",
            dataIndex: "assignedToName",
            key: "assignedToName",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "ETA for Resolution",
            dataIndex: "resolution",
            key: "resolution",
            width: 100,
            render: (text: string) => text || "N/A",
        },
    ]
    const fetchUserDropdown = async () => {
        try {
            const response = await tasksApis.getOwnersFilterData(
                projectId?.toString()
            );
            const { data, status } = response || {};
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };

                });
                setUserIdFilterData(options);
            }
        } catch (error) {
            console.error("eroor")
        }
    }


    useEffect(() => {
        fetchUserDropdown();
        dispatch(
            updateMenuData([
                {
                    text: "Onhold Tasks & Root Cause Report",
                    link: "pms/onhold-tasks-report",
                },
            ])
        );
    }, []);

    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='Onhold Tasks & Root Cause Report'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Task Planned Start Date",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "UserId",
                            label: "Users",
                            options: userIdFilterData,
                        },
                    ]
                }}
            />
        </>
    );
}

export default OnHoldTasksReport;